module.exports = __webpack_public_path__ + "static/14-f9287a3f1659e9ffb6275b07d3613bda.jpg";